import React from "react";
export var renderErrorMessage = function (message) {
    return (React.createElement("span", { className: "form__error" }, message));
};
